export const buyerCSAT = () => {
  (window as any).hj('event', 'comprador_reembolso');
};
